import SimpleFormDialog from "components/dialogs/SimpleFormDialog";
import { useTranslation } from "react-i18next";
import { queryOps } from "system/query/Query";
import { QueryBuilderAddButton } from "./QueryBuilderAddButton";
import { Box, Paper } from "@mui/material";
import { BuilderContext } from "components/queries/QueryBuilderPanel";
import React from "react";
import { QueryBranch } from "system/query/QueryBranch";
import { QuerySpan } from "system/query/QuerySpan";

export interface QueryBuilderAddPanelProps {
  isOpen: boolean;
  onClose: () => void;
  addLeafSegment: (op?: queryOps, parentBranch?: QueryBranch | QuerySpan, inSpan?: boolean, spanSide?: string) => void;
  addContainerSegment: (op?: queryOps, parentBranch?: QueryBranch | QuerySpan, inSpan?: boolean, spanSide?: string) => void;

  parentBranch?: QueryBranch | QuerySpan;
  inSpan?: boolean;
  spanSide?: string;
}

export default function QueryBuilderAddPanel(props:QueryBuilderAddPanelProps): JSX.Element {
  const { i18n } = useTranslation();
  const {draggingIsDisabled, setDraggingIsDisabled} = React.useContext(BuilderContext);

  React.useEffect(() => {
    if (draggingIsDisabled !== props.isOpen) {
      setDraggingIsDisabled(props.isOpen);
    }
  // Adding the supposed missing dependency causes an infinite loop
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const addContainer = (op:queryOps) => {
    setDraggingIsDisabled(false);
    props.addContainerSegment(op, props.parentBranch, props.inSpan, props.spanSide);
    props.onClose();
  }

  const addLeaf = (op?:queryOps) => {
    setDraggingIsDisabled(false);
    props.addLeafSegment(op, props.parentBranch, props.inSpan, props.spanSide);
    props.onClose();
  }

  return (
    <SimpleFormDialog
      isOpen={props.isOpen}
      onCancel={() => {
        setDraggingIsDisabled(false);
        props.onClose();
      }}
      onConfirm={()=>{setDraggingIsDisabled(false);}}
      hideConfirmButton={true}
      title={i18n.t("query-form.add-dialog-title")}
    >
      <Paper sx={{ p: 1 }}>
      <Box sx={{ textAlign: "center" }}>
        <QueryBuilderAddButton onClick={addLeaf} />
      </Box>
      </Paper>
      <Paper sx={{ p: 1, mt: 2 }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
        <Box>
          <QueryBuilderAddButton op={queryOps.and} onClick={() => addContainer(queryOps.and)} />
          <QueryBuilderAddButton op={queryOps.or} onClick={() => addContainer(queryOps.or)} />
          {!props.inSpan && <QueryBuilderAddButton op={queryOps.not} onClick={() => addContainer(queryOps.not)} />}
        </Box>
        <Box>
          {props.inSpan && <QueryBuilderAddButton op={queryOps.not} onClick={() => addContainer(queryOps.not)} />}
          {!props.inSpan && <QueryBuilderAddButton op={queryOps.span} onClick={() => addLeaf(queryOps.span)} />}
          {!props.inSpan && <QueryBuilderAddButton op={queryOps.boolean} onClick={() => addLeaf(queryOps.boolean)} />}
        </Box>
      </Box>
      </Paper>
    </SimpleFormDialog>
  );
}


